/* eslint-disable @typescript-eslint/no-unused-vars */
import Button from "components/Buttons/ThemeButton";
import styled, { CSSProperties, keyframes } from "styled-components";

export const Container = styled.div`
	position: relative;
	width: 100%;
	padding: 0px;
	position: relative;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	overflow: hidden;
	border-radius: 18px;
	font-size: clamp(1px, 4dvw, 19.5px);
	max-width: 450px;

	@media (min-width: 650px) {
		max-width: 100%;
		font-size: clamp(1px, 1.6dvw, 20px);
		justify-content: right;
	}
`;

export const DataContainer = styled.div`
	position: absolute;
	width: 93%;
	bottom: 4%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	@media (min-width: 650px) {
		flex-direction: row;
		justify-content: space-evenly;
		width: 100%;
		bottom: 12%;
	}

	&.event-completed {
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;

export const TitlesContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const TierContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const TierTitleContainer = styled.div<{ $backgroundImage: string }>`
	position: absolute;
	top: -1.8em;
	width: 15em;
	height: 4.7em;
	display: flex;
	z-index: 1;
	justify-content: center;
	align-items: center;
	background-image: url(${({ $backgroundImage }) => $backgroundImage});
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
	user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
`;

export const TierTitle = styled.div`
	color: #fff;
	text-align: center;
	-webkit-text-stroke-width: 0.18em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	font-family: Baloo;
	font-size: 1.2em;
	margin-top: -0.1em;
`;

export const BoxContainer = styled.div<{ $backgroundImage: string }>`
	position: relative;
	width: 21.5em;
	height: 12.5em;
	margin-top: 1em;
	margin-bottom: 2em;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-image: url(${({ $backgroundImage }) => $backgroundImage});
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
	}

	&.complete::before {
		filter: brightness(40%);
	}

	@media (min-width: 650px) {
		margin-bottom: 0.2em;
	}
`;

export const Background = styled.div<{ imageUrl?: string }>`
	background: url(${(props) => props.imageUrl});
	background-repeat: no-repeat;
	background-size: 100% 100%;

	width: 100%;
	height: 33em;

	@media (min-width: 650px) {
		width: 100%;
		height: 24em;
	}

	&.event-completed {
		::before {
			content: "";
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.4);
		}
	}
`;

export const Title = styled.img`
	width: 15em;
	user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;

	@media (min-width: 650px) {
		width: 25em;
		margin-bottom: 3.5em;
		margin-left: 2.5em;
	}

	&.event-completed {
		margin-left: 0em;
		margin-bottom: 1em;
	}
`;

export const Subtitle = styled.div`
	color: #fff;
	text-align: center;
	-webkit-text-stroke-width: 0.14em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	font-family: Baloo;
	font-style: normal;
	font-size: 1.8em;
	font-weight: 400;
	line-height: 100%;
`;

export const Wrapper = styled.div`
	position: relative;
	bottom: 4.4%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const RewardContainer = styled.div`
	width: 5.9em;
	display: flex;
	justify-content: center;
	align-items: center;

	&.complete {
		filter: grayscale(100) brightness(75%);
		opacity: 0.5;
		transition: filter 0.5s cubic-bezier(0.4, 0, 0.2, 1);
	}
`;

export const RewardItem = styled.img`
	height: 5.6em;
	z-index: 1;
	user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
`;

export const RewardAmout = styled.div`
	position: absolute;
	z-index: 1;
	bottom: -0.55em;
	right: 0em;
	color: #fff;
	text-align: center;
	-webkit-text-stroke-width: 0.15em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	font-family: Baloo;
	font-size: 2em;
	font-style: normal;
	font-weight: 400;
	line-height: 122%;
	user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
`;

export const Check = styled.img`
	position: absolute;
	//margin: 0 auto;
	height: 3.6em;
	z-index: 2;
	user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
`;

export const CustomButtom = styled(Button)`
	width: 95%;
	margin-top: 0.3em;
	height: 3.5em;
	font-size: 1em;

	@media (min-width: 650px) {
		margin-top: 0.1em;
		height: 3.2em;
		width: 80%;
	}
`;

export const InfoButton = styled.img`
	position: absolute;
	top: 0.8em;
	right: 0.9em;
	z-index: 1;
	width: 1.8em;
	height: 1.8em;
	cursor: pointer;

	&.message {
		top: 0.4em;
		right: 0.4em;
		width: 1.4em;
		height: 1.4em;
	}
`;

export const ClubName = styled.div`
	font-family: Inter;
	font-style: normal;
	font-weight: 700;
	background: rgba(255, 255, 255, 0.7);
	color: #6d6d6d;
	border-radius: 84.779px;
	opacity: 0.9;
	font-size: 0.9em;
	padding: 0.5em 0.7em;
	margin: 0.5em;
	width: fit-content;

	@media (min-width: 650px) {
		position: absolute;
		top: 0.3em;
		right: 3.2em;
	}
`;

export const ArrowButton = styled.img`
	position: absolute;
	z-index: 1;
	cursor: pointer;
	width: 3.5em;
	top: 4em;
	left: 2.8em;

	&.forward {
		left: unset;
		right: 2.8em;
	}
`;

export const Character = styled.img`
	position: absolute;
	top: 7.4em;
	left: -0.6em;
	width: 5.3em;

	&.right {
		top: 8em;
		left: unset;
		right: -0.2em;
		width: 5em;
	}

	@media (min-width: 650px) {
		top: unset;
		bottom: 2.7em;
		left: 0.5em;

		&.right {
			top: unset;
			bottom: 3.2em;
			right: unset;
			left: 5.5em;
			transform: scaleX(-1);
		}
	}
`;

export const StarBurstFrames = keyframes`
   from {
        transform: translate(-50%, -50%) rotateZ(0deg);
    }
    to {
        transform: translate(-50%, -50%) rotateZ(360deg);
    }   
`;

export const StarBurst = styled.img`
	animation: ${StarBurstFrames} 14s linear infinite;
	position: absolute;
	width: 12em;
	height: 12em;
	top: 50%;
	left: 50%;
	user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	opacity: 0;
	transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);

	&.active {
		opacity: 1;
	}
`;

export const MessageContainer = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	border-radius: 8px;
	background: rgba(0, 0, 0, 0.5);
	bottom: 15.6%;
	padding: 0.1em;
	width: 90%;
	height: 2em;
	@media (min-width: 650px) {
		justify-content: center;
		bottom: 11%;
		left: 11em;
		width: 17.5em;
		height: 3em;
		padding: 0.2em;
	}
`;

export const Message = styled.div`
	text-align: center;
	color: #fff;
	font-size: 0.8em;
	width: 90%;

	@media (min-width: 650px) {
		font-size: 0.9em;
		width: 75%;
	}
`;
